// Identity values are obfuscated wherever they are listed (shoulder-surfing / screenshots).
// The Super Admin reveals them one at a time on the person detail.
export function maskIdentity(kind, value) {
  const v = String(value || "");
  if (!v) return v;
  const stars = (n) => "*".repeat(Math.max(1, n));
  if (kind === "email" && v.includes("@")) {
    const [u, d] = v.split("@");
    return `${u.slice(0, 2)}${stars(Math.max(1, u.length - 2))}@${d}`;
  }
  if (kind === "phone") return `${v.slice(0, 3)}${stars(Math.max(1, v.length - 7))}${v.slice(-4)}`;
  if (kind === "cpf") {
    const d = v.replace(/\D/g, "");
    return d.length >= 9 ? `***.${d.slice(3, 6)}.${d.slice(6, 9)}-**` : stars(v.length);
  }
  return v.length <= 4 ? stars(v.length) : `${v.slice(0, 2)}${stars(v.length - 4)}${v.slice(-2)}`;
}

export default maskIdentity;
